import { computed } from 'vue'
import { useAuthStore } from '/auth.js'

const clubEventTypes = [
  { title: 'Závody',      value: 'races'    },
  { title: 'Soustředění oddílu', value: 'camp'     },
  { title: 'Trénink',     value: 'training' },
  { title: 'Ostatní',     value: 'other'    },
]
const specialEventTypes = [
  { title: 'Reprezentační akce', value: 'repre',    visible: s => s.isOrganizer('RCZ') },
  { title: 'SCM akce',           value: 'scm',      visible: s => s.isOrganizer('SCM') },
  { title: 'Asociační akce',     value: 'association', visible: s => s.isManager() },
]

export function EventTypes() {
  const auth = useAuthStore()
  const isClubOrganizer = computed(() => auth.clubPermissions.includes('organizer'))

  const eventTypes = computed(() => {
    const list = []
    if (isClubOrganizer.value) list.push(...clubEventTypes)
    specialEventTypes.forEach(o => {
      if (o.visible(auth)) list.push({ title: o.title, value: o.value })
    })
    return list
  })

  const eventTypeRule = [ v => !!v || 'Vyber typ' ]

  return { eventTypes, eventTypeRule }
}
